import React, { useEffect } from "react";
import ViewMaster from "../../Components/ViewMaster/ViewMaster";

function Dmca() {
  useEffect(() => {
    document.title = "Zesty games | Privacy Policy & Terms of Use";
  }, []);
  return (
    <>
      <div>
        <div className="bgContent" style={{ "background-color": "#ffffff" }}>
          <div className="container py-4 text-white fs-20">
            <div className="txblack">
              <h4 className="DescriptionHeading">
                <strong>DMCA Notice for ZestyGame.com</strong>
              </h4>
              <div>
                <p>
                  <strong>Introduction:</strong>
                </p>

                <p>
                  At ZestyGame.com, we respect intellectual property rights and
                  comply with the Digital Millennium Copyright Act (DMCA). All
                  the games, articles, and other content available on our
                  website are sourced from public domains and trusted sources
                  across the web. We believe that all the content we publish is
                  compliant with copyright laws. However, if you believe that
                  any of your copyrighted work has been used without
                  authorization, please don’t hesitate to contact us.
                </p>

                <p>
                  <strong>Our Content:</strong>
                </p>

                <p>
                  Our team at ZestyGame.com is committed to publishing
                  authentic, informative, and engaging content, which is sourced
                  from trusted websites, gaming news platforms, official
                  documents, and press releases. The content is intended for
                  gaming enthusiasts and is curated to enhance your gaming
                  experience.
                </p>

                <p>
                  <strong>
                    What to Do If You Believe Your Work Is Infringed:
                  </strong>
                </p>

                <p>
                  If you believe your copyrighted material has been used without
                  permission on our website, please provide the following
                  details:
                </p>

                <ul>
                  <li>
                    <strong>Description of the copyrighted work:</strong> Please
                    provide a brief description of your work that you believe
                    has been infringed.
                  </li>
                  <li>
                    <strong>Location or URL of the infringing content:</strong>{" "}
                    Indicate where on our site we are using your copyrighted
                    content. Please provide the URL(s) where the content
                    appears.
                  </li>
                  <li>
                    <strong>Contact Information:</strong> Provide your name,
                    email, and phone number so we can contact you for further
                    information.
                  </li>
                  <li>
                    <strong>Statement of Unauthorized Use:</strong> Please
                    affirm that you believe the material has been used without
                    your authorization, and confirm that you are the copyright
                    owner or authorized to act on behalf of the copyright owner.
                  </li>
                </ul>

                <p>
                  <strong>How to Contact Us:</strong>
                </p>

                <p>
                  Once you have gathered the necessary details, please send the
                  information to us via email at{" "}
                  <a href="mailto:support@ZestyGame.com">
                    support@ZestyGame.com
                  </a>
                  . We will review your claim and take the appropriate steps to
                  resolve the issue within 7 days of receiving your notice.
                </p>

                <p>
                  We take copyright infringement seriously and will promptly
                  respond to any concerns related to unauthorized content usage.
                  Thank you for helping us maintain a legal and ethical gaming
                  community.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewMaster(Dmca);
